import fetchWithOptions from '../../../shared/utils/fetch';
import {
  LoginProps,
  Organization,
  ServerOrganization,
  ServerUser,
  User,
} from '../types/auth';

export const login = async ({
  email,
  password,
}: LoginProps): Promise<User | null> => {
  try {
    const userData = await fetchWithOptions('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });

    return jsonToUser(userData);
  } catch {
    return null;
  }
};

export const logout = async (): Promise<boolean> => {
  try {
    await fetchWithOptions('/api/auth/logout', {
      method: 'POST',
    });

    return true;
  } catch {
    return false;
  }
};

export const checkStatus = async (): Promise<User | null> => {
  try {
    const userData = await fetchWithOptions<ServerUser>('/api/auth/whoami');
    return jsonToUser(userData);
  } catch {
    return null;
  }
};

const jsonToUser = (json: ServerUser): User => {
  return {
    id: json.uuid,
    email: json.email,
    name: json.name,
    interface: jsonToInterface(json.interfaces),
    role: jsonToRole(json.role),
    qualityRole: jsonToQualityRole(json.organizations),
    organization: jsonToOrganization(json.organizations),
  };
};

const jsonToInterface = (json: ServerUser['interfaces']): User['interface'] => {
  return json['platane'] ? 'platane' : null;
};

const jsonToRole = (json: ServerUser['role']): User['role'] => {
  switch (json) {
    case 'algo_only':
      return 'algo_only';
    case 'admin':
      return 'admin';
    case 'medic':
      return 'medic';
    case 'cardio':
      return 'cardio';
    default:
      throw new Error('Role must be one of: algo_only, admin, medic, cardio');
  }
};

const jsonToQualityRole = (
  organizations: ServerUser['organizations'],
): User['qualityRole'] => {
  if (organizations == null) {
    return 'annotator';
  }
  switch (organizations[0]?.quality_role) {
    case 'reviewer':
      return 'reviewer';
    case 'scanner':
    default:
      return 'annotator';
  }
};

const jsonToOrganization = (
  organizations?: ServerOrganization[],
): Organization | undefined => {
  if (organizations == null || organizations[0] == null) {
    return undefined;
  }
  const { id, name } = organizations[0];

  return { id, name };
};
